var React = require('react');

function SurebroIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#212121"},React.createElement("g",{"transform":"translate(0 -1078.98)"},React.createElement("rect",{"y":"1078.98","width":"48","height":"48","rx":"12"})))));
}

SurebroIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = SurebroIcon;

SurebroIcon.default = SurebroIcon;
